import React from 'react';
import {Link} from 'react-router-dom';
import styles from './styles.module.scss';
import NewTabTooltip from '../../../shared/components/new-tab-tooltip';

export interface NavbarButtonProps {
  path?: string;
  title: string;
  routed?: boolean;
  newTab?: boolean;
  // TODO: used in files that import this type
  disabled?: boolean;
  isActiveLink?: boolean;
  requiresAnyFeatureFlag?: string[];
  iconType?: string;
}

const NavbarButton = ({path, title, routed, newTab, isActiveLink}: NavbarButtonProps) => {
  const sharedProps = {
    ['data-testid']: 'navbar-link',
    className: styles.link,
    target: newTab ? '_blank' : '_self',
  };

  const content = (
    <>
      {title}
      {isActiveLink && <div className={styles.activeLink} data-testid="active-indicator"></div>}
    </>
  );

  if (routed && path) {
    return (
      <Link to={path} {...sharedProps}>
        {content}
      </Link>
    );
  }

  if (sharedProps.target === '_blank') {
    return (
      <NewTabTooltip>
        <a href={path} {...sharedProps}>
          {content}
        </a>
      </NewTabTooltip>
    );
  }

  return (
    <a href={path} {...sharedProps}>
      {content}
    </a>
  );
};

NavbarButton.defaultProps = {
  newTab: false,
};

export default NavbarButton;
